var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingWarehouse.addAndEdit.code"),
                prop: "storehouseNo",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  placeholder: _vm.$t(
                    "settingWarehouse.addAndEdit.warehouseText"
                  ),
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  disabled: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.openWarehouseDialog()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "settingWarehouse.addAndEdit.selectWarehouse"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.form.storehouseNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "storehouseNo", $$v)
                  },
                  expression: "form.storehouseNo",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingWarehouse.addAndEdit.name"),
                prop: "storehouseName",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  placeholder: _vm.$t(
                    "settingWarehouse.addAndEdit.warehouseText"
                  ),
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  disabled: "",
                },
                model: {
                  value: _vm.form.storehouseName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "storehouseName", $$v)
                  },
                  expression: "form.storehouseName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingWarehouse.addAndEdit.logistics"),
                prop: "logisticCompanyId",
              },
            },
            [
              _c("BjSelectLogisticCompany", {
                attrs: {
                  value: _vm.form.logisticCompanyId,
                  "default-options": {
                    label: _vm.form.logisticCompanyName,
                    value: _vm.form.logisticCompanyId,
                  },
                },
                on: { change: _vm.onLogistic },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingWarehouse.addAndEdit.business"),
                prop: "logisticBusinessId",
              },
            },
            [
              _c("BjSelectLogisticBusiness", {
                attrs: {
                  value: _vm.form.logisticBusinessId,
                  disabled: !_vm.form.logisticCompanyId,
                  "default-params": _vm.defaultParams,
                  "default-options": {
                    label: _vm.form.logisticBusinessName,
                    value: _vm.form.logisticBusinessId,
                  },
                  placeholder: _vm.form.logisticCompanyId
                    ? _vm.$t("chooseText")
                    : _vm.$t("settingWarehouse.addAndEdit.logisticsText"),
                },
                on: { change: _vm.onBusiness },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingWarehouse.addAndEdit.priority"),
                prop: "orderNum",
              },
            },
            [
              _c("el-input-number", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  min: 0,
                  max: _vm.MAX_LENGTH.PRIORITY,
                  precision: 0,
                  controls: false,
                },
                model: {
                  value: _vm.form.orderNum,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "orderNum", $$v)
                  },
                  expression: "form.orderNum",
                },
              }),
              _c("span", { staticClass: "text-muted font12 ml0" }, [
                _vm._v(
                  _vm._s(_vm.$t("settingWarehouse.addAndEdit.priorityText"))
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingWarehouse.addAndEdit.express"),
                prop: "deliveryCheck",
              },
            },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.form.deliveryCheck,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "deliveryCheck", $$v)
                  },
                  expression: "form.deliveryCheck",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingWarehouse.addAndEdit.returnExpress"),
                prop: "returnGoodsCheck",
              },
            },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.form.returnGoodsCheck,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "returnGoodsCheck", $$v)
                  },
                  expression: "form.returnGoodsCheck",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "warehouse",
        attrs: {
          "row-keys": "code",
          config: _vm.$BjDialogListConfig.stockWarehouseLogic(),
          disabled: _vm.dialogDisabled,
        },
        on: { confirm: _vm.onConfirmWarehouseList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }